import { routes } from "@/constants/routes";
import { useTheme } from "@/theme/ThemeProvider";
import { LinkText } from "@/ui/components/LinkText";
import { useRouter } from "expo-router";
import { ScrollView, Text, View } from "react-native";

/**
 * P1: Keine freie Registrierung – Zugang nur per Einladung.
 */
export default function RegisterScreen() {
  const { theme } = useTheme();
  const router = useRouter();

  return (
    <ScrollView
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: "center",
        padding: theme.space.xl,
        backgroundColor: theme.color.bg,
        gap: theme.space.md,
      }}
    >
      <Text
        style={{
          fontSize: theme.fontSize.title,
          fontWeight: "700",
          color: theme.color.text,
        }}
      >
        Zugang nur mit Einladung
      </Text>
      <Text style={{ color: theme.color.textSecondary, fontSize: theme.fontSize.body }}>
        Ferina Cura erlaubt keine freie Registrierung. Ein Vorstandsmitglied oder
        Administrator lädt dich per E-Mail ein. Anschließend legst du über den Link in der
        Mail dein Passwort fest.
      </Text>
      <View style={{ marginTop: theme.space.md }}>
        <LinkText onPress={() => router.replace(routes.login as any)}>Zur Anmeldung</LinkText>
      </View>
    </ScrollView>
  );
}
